import { combineReducers, Reducer } from 'redux';
import { reducer as billingAddressReducer } from 'b2b-apps/shop/myAccount/accountDetails/redux/billingAddress/reducer';
import { reducer as detailsReducer } from 'b2b-apps/shop/myAccount/accountDetails/redux/details/reducer';
import { AccountDetailsAction, AccountDetailsState } from './types';

const reducer: Reducer<
  AccountDetailsState,
  AccountDetailsAction
> = combineReducers({
  billingAddress: billingAddressReducer,
  details: detailsReducer,
});

export {
  reducer,
};
